// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment/types';

export function paynetOutgoingPaymentMapper(): $Shape<OutgoingPayment> {

  return {
    payment_type: 'paynet',
    payment_type_code: 'paynet',
  };
}
